// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Button,
  //   TextField,
  //   MenuItem,
  //   Select,
  //   FormControl,
  //   InputLabel,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";

function LeadProfileViewPage() {
  const pageTitle = "Lead Profile";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [leadProfile, setLeadProfile] = useState({});
  const [customFields, setCustomFields] = useState([]);
  //   const [customFieldsRaw, setCustomFieldsRaw] = useState([]);
  //   const [customFieldValues, setCustomFieldValues] = useState({});
  const [leads, setLeads] = useState(0);

  const [customFieldTitle, setCustomFieldTitle] = useState(null);
  const [customFieldOptions, setCustomFieldOptions] = useState(null);
  const [selectedCustomField, setSelectedCustomField] = useState(null);
  const [openNewFieldDialog, setOpenNewFieldDialog] = useState(false);
  const [openEditFieldDialog, setOpenEditFieldDialog] = useState(false);

  const [leadBuckets, setLeadBuckets] = useState([]);
  const [title, setTitle] = useState(null);
  const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);

  // const [leadName, setLeadName] = useState(null);
  // const [leadEmailAddress, setLeadEmailAddress] = useState(null);
  // const [leadPhoneNumber, setLeadPhoneNumber] = useState(null);
  // const [uploadFile, setUploadFile] = useState(null);
  // const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);
  // const [openUploadAgentsDialog, setOpenUploadAgentsDialog] = useState(false);

  async function deleteCustomField(reference) {
    setShowLoading(true);
    await axios
      .get(`portal/leads/types/attributes/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteLeadProfile(reference) {
    setShowLoading(true);

    await axios
      .get(`portal/leads/types/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const customFieldTableColumns = [
    { Header: "Attribute", accessor: "field", align: "left" },
    { Header: "Key", accessor: "code", align: "left" },
    { Header: "Options", accessor: "options", align: "left" },
    { Header: "Actions", accessor: "action", align: "right" },
  ];

  const buildCustomFieldRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        field: row.title,
        code: row.code,
        options: row.options.length > 0 ? row.options.join(",") : "---",
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Edit">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  setSelectedCustomField(row);
                  setCustomFieldTitle(row.title);
                  setCustomFieldOptions(row.options.length > 0 ? row.options.join(",") : null);
                  setOpenEditFieldDialog(true);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  edit_note
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(
                      `Remove ${row.title}? All related saved records will be deleted permanently!`
                    ) === true
                  ) {
                    deleteCustomField(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  async function deleteLeadBucket(reference) {
    setShowLoading(true);

    await axios
      .get(`portal/leads/buckets/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const bucketColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Leads", accessor: "count", align: "left" },
    { Header: "Actions", accessor: "action", align: "right" },
  ];

  const buildLeadBucketRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        count: row.count,
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Manage Bucket">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  navigate(`/leads/buckets/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  settings
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete bucket: ${row.title}?`) === true) {
                  deleteLeadBucket(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/leads/types/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setLeadProfile(result.data.data.profile);
            setLeads(result.data.data.leads);
            // setCustomFieldsRaw(result.data.data.attributes);
            const rowsF = buildCustomFieldRows(result.data.data.attributes);
            setCustomFields(rowsF);

            const rows = buildLeadBucketRows(result.data.data.buckets);
            setLeadBuckets(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createCustomField() {
    if (customFieldTitle === null) {
      setSeverity("error");
      setErrMsg("Attribute name is required.");
      setOpen(true);
      return;
    }

    setOpenNewFieldDialog(false);
    setShowLoading(true);
    const json = {
      name: customFieldTitle,
      options: customFieldOptions,
      reference: leadProfile.reference,
    };

    await axios
      .post("portal/leads/types/attributes/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editCustomField() {
    if (customFieldTitle === null) {
      setSeverity("error");
      setErrMsg("Attribute name is required.");
      setOpen(true);
      return;
    }

    setOpenEditFieldDialog(false);
    setShowLoading(true);
    const json = {
      name: customFieldTitle,
      options: customFieldOptions,
      reference: selectedCustomField.reference,
    };

    await axios
      .post("portal/leads/types/attributes/edit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createLeadBucket() {
    if (title === null) {
      setSeverity("error");
      setErrMsg("Bucket name is required.");
      setOpen(true);
      return;
    }

    setOpenNewCheckDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
      profile: ref,
    };

    await axios
      .post("portal/leads/buckets/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openNewFieldDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Attribute</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={3}>
              <MDInput
                name="field_name"
                margin="dense"
                label="Attribute Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setCustomFieldTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                multiline
                minRows={3}
                placeholder="Comma separated values"
                name="field_options"
                margin="dense"
                label="Attribute Options (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setCustomFieldOptions(e.target.value)}
              />
              <small>Comma separated values</small>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createCustomField();
            }}
          >
            Add Attribute
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditFieldDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Edit Attribute</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={3}>
              <MDInput
                name="field_name"
                margin="dense"
                label="Attribute Name"
                type="text"
                fullWidth
                variant="outlined"
                value={customFieldTitle}
                onChange={(e) => setCustomFieldTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                multiline
                minRows={3}
                placeholder="Comma separated values"
                name="field_options"
                margin="dense"
                label="Attribute Options (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                value={customFieldOptions}
                onChange={(e) => setCustomFieldOptions(e.target.value)}
              />
              <small>Comma separated values</small>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              editCustomField();
            }}
          >
            Save Attribute
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewCheckDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>New Lead Bucket</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={3}>
              <MDInput
                name="title"
                margin="dense"
                label="Bucket Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewCheckDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="dark"
            onClick={() => {
              createLeadBucket();
            }}
          >
            Create Bucket
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mb={5}>
        <MDBox pt={3} pb={3}>
          <MDBox mt={0} mb={1} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/leads/profiles`);
                }}
              >
                Back
              </Button>
            </MDBox>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8} lg={8}>
              <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                          Lead Profile
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="medium">
                          {leadProfile.title}
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <Tooltip title="Delete Profile">
                          <MDButton
                            variant="contained"
                            color="error"
                            iconOnly
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Delete Profile? All related saved records will be deleted permanently!"
                                ) === true
                              ) {
                                deleteLeadProfile(ref);
                              }
                            }}
                          >
                            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                              delete
                            </Icon>
                          </MDButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <MDBox>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={2} align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="light">
                        Leads
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={0}>
                      <MDTypography variant="h6" fontWeight="medium" fontSize={36}>
                        {leads}
                      </MDTypography>
                    </MDBox>
                    {/* <MDBox mt={3}>
                    <MDBox>
                      <Tooltip title="Add Lead">
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            // if (customFieldsRaw.length <= 0) {
                            //   setSeverity("error");
                            //   setErrMsg("Lead bucket attributes are required.");
                            //   setOpen(true);
                            //   return;
                            // }
                            setCustomFieldValues({});
                            setOpenNewCheckDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Upload Leads">
                        <MDButton
                          variant="outlined"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            // if (customFieldsRaw.length <= 0) {
                            //   setSeverity("error");
                            //   setErrMsg("Lead bucket attributes are required.");
                            //   setOpen(true);
                            //   return;
                            // }
                            setOpenUploadAgentsDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox> */}
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={5}>
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox>
              <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    Attributes
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                    Define profile attributes unique to your use-case.
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <Tooltip title="Add Field">
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setCustomFieldTitle(null);
                        setCustomFieldOptions(null);
                        setOpenNewFieldDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </Tooltip>
                </MDBox>
              </MDBox>
              <MDBox mt={5}>
                <DataTable
                  table={{ columns: customFieldTableColumns, rows: customFields }}
                  isSorted
                  canSearch={false}
                  entriesPerPage={false}
                  showTotalEntries
                  noEndBorder
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        {leadBuckets.length > 0 ? (
          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium">
                    Lead Buckets
                  </MDTypography>
                  <MDBox>
                    <MDButton
                      variant="contained"
                      color="dark"
                      onClick={() => {
                        setOpenNewCheckDialog(true);
                      }}
                      iconOnly
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox mt={5}>
                  <DataTable
                    table={{ columns: bucketColumns, rows: leadBuckets }}
                    isSorted
                    canSearch={false}
                    entriesPerPage={false}
                    showTotalEntries
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        ) : (
          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDBox align="center">
                  <MDBox>
                    <MDTypography variant="h6" fontSize={48}>
                      <Icon>contacts</Icon>
                    </MDTypography>
                    <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                      Organise leads in buckets. Assign to teams, track conversions, drop-offs and
                      much more.
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={5} mb={3}>
                    <MDButton
                      variant="contained"
                      color="dark"
                      onClick={() => {
                        setOpenNewCheckDialog(true);
                      }}
                      startIcon={<Icon>add</Icon>}
                    >
                      Create Bucket
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        )}
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default LeadProfileViewPage;
